module.exports = ".red-i{\n    color: red !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/client/register/register.component.css
// module id = ./src/app/client/register/register.component.css
// module chunks = main